<template>
  <CompleteSignupProgress
    :currentStep="currentStep"
    :stepNames="['Set up admin', 'Set up agency', 'Invite team (optional)']" />
</template>

<script>
import CompleteSignupProgress from '@components/sign-up/complete-signup-progress/CompleteSignupProgress.vue'

export default {
  name: 'CompleteSignupProgressRegular',
  components: { CompleteSignupProgress },
  props: {
    currentStep: {
      type: Number,
      required: true
    }
  }
}
</script>
